import React from 'react';
import styles from './EapSessionsInfo.module.scss';
import useTranslator from '../../../hooks/useTranslator';

const EapSessionsInfo = ({ eapSessionData, isMss = false, locale = 'en' }) => {
  const translator = useTranslator(locale);
  const sessionCountExclusionText = isMss
    ? translator.mss_session_count_exclusion_text
    : 'The session count may exclude visits not yet billed by a provider.';
  const containerClass = isMss
    ? styles.mssContainer
    : `${styles.callCenterContainer} margin-bottom-2-5rem`;

  return eapSessionData &&
    typeof eapSessionData === 'object' &&
    (eapSessionData.authorizedSessions !== undefined ||
      eapSessionData.authorizedSessionsUsed !== undefined ||
      eapSessionData.authorizedSessionsRemaining !== undefined) ? (
    <div className={`${styles.container} ${containerClass} text-align-left`}>
      <div className={`grid ${styles.gridProperties} column-gap-md`}>
        <p className="margin-0">
          <b>{translator.eap_sessions_used}:</b>
        </p>
        <p className="margin-0">
          {eapSessionData?.authorizedSessionsUsed} {translator.out_of}{' '}
          {eapSessionData?.authorizedSessions}
        </p>
        <p className="margin-0">
          <b>{translator.eap_sessions_remaining}:</b>
        </p>
        <p
          className={`margin-0 ${
            eapSessionData.authorizedSessionsRemaining > 0 ? '' : 'error-color'
          }`}
        >
          {eapSessionData.authorizedSessionsRemaining > 0
            ? eapSessionData.authorizedSessionsRemaining
            : translator.eap_sessions_used_all}
        </p>
      </div>
      {(eapSessionData.authorizedSessionsRemaining > 0 || isMss) && (
        <p className="margin-0 margin-top-md">
          <i>{sessionCountExclusionText}</i>
        </p>
      )}
    </div>
  ) : null;
};

export default EapSessionsInfo;
